export const DARK = true;
